var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("portal", { attrs: { to: "modals" } }, [
    _c(
      "div",
      {
        staticClass: "modal is-active",
        class: { "modal-full-height": _vm.fullHeight }
      },
      [
        _c("div", { staticClass: "modal-background" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "modal-card", style: { "max-width": _vm.width } },
          [
            _c("header", { staticClass: "modal-card-head p-3 lg:p-5" }, [
              _c("p", {
                staticClass: "modal-card-title text-lg lg:text-xl",
                domProps: { textContent: _vm._s(_vm.title) }
              }),
              _vm._v(" "),
              _vm.showCloseButton
                ? _c("button", {
                    staticClass: "delete",
                    attrs: { "aria-label": "close" },
                    on: {
                      click: function($event) {
                        return _vm.$emit("close")
                      }
                    }
                  })
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "modal-card-body overscroll-contain" },
              [_vm._t("default")],
              2
            ),
            _vm._v(" "),
            _c(
              "footer",
              { staticClass: "modal-card-foot p-3 lg:p-5" },
              [_vm._t("footer")],
              2
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2fa642f3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fa642f3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/Modal.vue
// module id = null
// module chunks = 